console.log("cart-functions running");
// Add product to cart
function addToCart(productId, quantity) {
  console.log("Cart from cart functions");
  var $btn = $(this);
  if ($btn.data("clicked")) return;

  $btn.data("clicked", true);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: productId,
      quantity: quantity,
    },
    success: function (data) {
      window.location.href = window.location.origin + "/cart";
    },
    error: function (xhr) {
      console.error("Error adding to cart:", xhr.responseText);
    },
  });
}

// Remove product from cart
function removeFromCart(productId) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: productId,
      quantity: 0,
    },
    success: function (data) {
      window.location.href = window.location.origin + "/cart";
    },
    error: function (xhr) {
      console.error("Error removing from cart:", xhr.responseText);
    },
  });
}

// Events
$(document).ready(function () {
  // General Add to Cart button
  $("body").on("click", ".add_cart_btn", function (e) {
    e.preventDefault();
    const $this = $(this);
    const productId = $("input.sel-var-id").val(); // fallback if no data-id
    console.log("Selected product id" + productId);
    const quantity = $(".quantity__input").val() || 1;

    if (productId) {
      addToCart(productId, quantity);
    }
  });

  // Remove item from cart
  $("body").on("click", ".custom_product_remve_cart", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const productId = $(this).attr("var-id");

    if (productId) {
      removeFromCart(productId);
    }
  });

  // Quick Add Button
  $("body").on("click", "button.custom_quick_add_buttons", function (e) {
    e.preventDefault();
    const productId = $(this).attr("attr");
    const quantity =
      $(".quick_add_button.mobile_only input.product-qty").val() || 1;

    if (productId) {
      addToCart(productId, quantity);
    }
  });
});
